<template>
  <div class="formRowContainer grid formStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormRowContainer'
};
</script>

<style lang="scss" scoped>
.formRowContainer > * {
  width: 100%;
}

@media (min-width: 768px) {
  .formStyle {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}
</style>
